const IndustriesSection = () => {
  const industries = [
    {
      name: 'Private Clinical Practices',
      description:
        'Independent physician practices seeking operational excellence and growth strategies.',
    },
    {
      name: 'Standalone Clinical Groups',
      description:
        'Multi-physician groups requiring coordinated operational and technology solutions.',
    },
    {
      name: 'Multi-Provider Practices',
      description:
        'Practices with multiple providers needing scalable systems and workflows.',
    },
    {
      name: 'Specialty Clinics',
      description:
        'Specialized medical practices requiring tailored operational and marketing strategies.',
    },
    {
      name: 'Physician-Led Organizations',
      description:
        'Clinical organizations led by physicians focused on quality care and operational efficiency.',
    },
    {
      name: 'Emerging Clinical Ventures',
      description:
        'New clinical practices establishing operational foundations and growth frameworks.',
    },
  ];

  return (
    <section id="industries" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-xs uppercase tracking-widest text-gold mb-4 font-semibold">
            INDUSTRIES SERVED
          </p>
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-navy-primary mb-8">
            Clinical Organizations We Serve
          </h2>
          <p className="text-base text-charcoal max-w-3xl mx-auto leading-relaxed">
            We specialize in serving a diverse range of clinical organizations,
            from independent practices to multi-provider groups.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {industries.map((industry, index) => (
            <div
              key={index}
              className="flex items-start space-x-4 p-6 rounded-2xl hover:bg-gray-bg transition-all duration-300 cursor-pointer group"
            >
              <div className="w-2 h-2 bg-gold rounded-full mt-2 group-hover:scale-150 transition-transform duration-300"></div>
              <div>
                <h3 className="text-lg font-bold text-navy-primary mb-2">
                  {industry.name}
                </h3>
                <p className="text-sm text-charcoal leading-relaxed">
                  {industry.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;